import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { AnexarImagensComponent } from '../anexar-imagens/anexar-imagens.component';


@Component({
  selector: 'app-imagens-tratamento',
  templateUrl: './imagens-tratamento.component.html',
  styleUrls: ['./imagens-tratamento.component.scss']
})
export class ImagensTratamentoComponent implements OnInit {

  @ViewChild('modalImagens') modalImagens: AnexarImagensComponent;

  @Input() alerta: string;
  @Input() codigoBeneficiario: string;
  @Input() corTitulo = '#00985C';
  @Input() errorGuia = false;
  @Input() listaAnexos;
  @Input() numeroGTO: string;
  @Input() permitirAnexarImagem = false;
  @Input() prestExecutanteCodigo: string;
  @Input() somenteGuia = false;
  @Input() subTitulo = 'Selecione as imagens do tratamento e faça o upload';
  @Input() titulo = 'Imagens do Tratamento';

  @Output() anexoChange = new EventEmitter();
  @Output() attachErrorEmmiter = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit() { }

  private abrirModalAnexarImagens() {
    this.modalImagens.show();
  }

  public attachError(error: boolean) {
    this.attachErrorEmmiter.emit(error);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/imagens-tratamento/imagens-tratamento.component.ts